import styled from "styled-components";

export const Container = styled.div`
  max-width: 144rem;
  padding: 0 2rem;
  margin: 0 auto;
`;
